module.exports = __webpack_public_path__ + "static/media/calendar-icon.c24c4534.svg";